// @owners { team: patients-team }
import { COLORS } from '@alto/design-library-tokens';
import { AltoIcon, Pressable, Tag } from '@alto/design-system';
import React from 'react';

export type Props = {
  readonly onPress?: () => void;
};

export const WaitingOnProgynyTag = ({ onPress }: Props) => {
  if (onPress) {
    return (
      <Pressable
        backgroundColor={COLORS.BACKGROUND_COLORS.TRANSPARENT}
        onPress={onPress}
      >
        <Tag
          label="waiting on progyny"
          icon={<AltoIcon name="chevrondown-small" />}
          right
        />
      </Pressable>
    );
  } else {
    return (
      <Tag
        label="waiting on progyny"
        icon={<AltoIcon name="chevrondown-small" />}
        right
      />
    );
  }
};
